import Flickity from "flickity";

const removeVideoPoster = function () {
  const iframes = Array.from(document.querySelectorAll('.media-container iframe'));

  if (!iframes.length) return;

  iframes.forEach((i) => {
    const player = new Vimeo.Player(i);
    player.on('play', () => {
      i.style.backgroundImage = 'none';
    });
  });
};

const activateSwiper = function () {
  if (!window.videoImageBlocks?.sections.length) {
    return;
  }
  const isMobile = window.matchMedia('(max-width: 750px)').matches;
  if (isMobile) {
    window.videoImageBlocks.sections.forEach(
      (c) => {
        new Flickity(c.section, {
          pageDots: false,
          wrapAround: true,
          autoPlay: 5000,
          prevNextButtons: false,
          cellAlign: c.blockSize === 4 ? 'left' : 'center',
        });
      },
    );
  }
};

const init = function () {
  activateSwiper();
  removeVideoPoster();
};

export default init;
